import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-plugin",
  "use": "icon-si-glyph-plugin-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-plugin\" id=\"icon-si-glyph-plugin\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>881</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(0.000000, 4.000000)\" fill=\"#434343\">\n            <path d=\"M5.016,3.038 L0.016,3.038 L0.016,5.969 L5.016,5.969 L5.016,6.798 L10.938,8.973 L10.938,0.043 L5.016,2.219 L5.016,3.038 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M15.953,2.984 L15.953,2.016 L12.982,2.016 L12.982,0.043 L12.02,0.043 L12.02,8.973 L12.982,8.973 L12.982,6.984 L15.953,6.984 L15.953,6.016 L12.982,6.016 L12.982,2.984 L15.953,2.984 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-plugin.svg
// module id = l1pX
// module chunks = 62